var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.unsubscribed)?_c('div',{staticClass:"container"},[_vm._v("You have successfully unsubscribed!")]):_vm._e(),(_vm.error)?_c('div',{staticClass:"container"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),(_vm.loading)?_c('loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }